<div class="w-100 h-100">
    <div class="row" style="padding-top: 25px;padding-bottom: 25px;">
        <div class="col-md-12">
            <label class="header_text mb-3">
                {{$t('shared.sendersRenewal')}}
            </label>
        </div>
    </div>
    <div class="row justify-content-sm-center" v-if="!isSelectOption">
        <div class="col-sm-8" v-if="!isSelectOption">
            <v-stepper alt-labels :value="stepNumber" v-if="!isSelectOption">
                <v-stepper-header>
                    <v-stepper-step step="1" :class="{'complete': stepNumber > 1}">{{$t('shared.clientInfo')}}</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="2" :class="{'complete': stepNumber > 2}">{{$t('shared.renewalInfo')}}</v-stepper-step>
                </v-stepper-header>
            </v-stepper>
        </div>
    </div>
    <!-- Step 11111111111 -->
    <div class="row justify-content-center" v-if="stepNumber == 1  && !isSelectOption">
        <div class="col-md-12 pr-0">
            <div class="card card_layout">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>{{$t('shared.customerType')}}</label>
                                <v-select v-model="model.customerType" :items="customerTypeList" :label="$t('shared.select')"
                                          item-text="name" item-value="id" solo>
                                </v-select>
                            </div>
                        </div>
                        <div class="col-md-4 mb-3" v-if="model.customerType !== 0 && model.customerType !== 3">
                            <div class="form-group">
                                <label v-if="model.customerType === 1">{{$t('shared.budgetNumber')}}</label>
                                <label v-if="model.customerType === 2">{{$t('shared.licenseNumber')}}</label>
                                <label v-if="model.customerType === 4">{{$t('shared.internationalCommercialRegistrationNumber')}}</label>
                                <input class="form-control" v-model="model.crNumber" type="text" />
                            </div>
                        </div>
                        <div class="col-md-4 mb-3" v-if="model.customerType === 2 ||model.customerType === 3 ">
                            <div class="form-group">
                                <label>{{$t('shared.enterpriseUnifiedNumber')}}</label>
                                <input class="form-control" v-model="model.enterpriseUnifiedNumber" type="text" />
                            </div>
                        </div>
                        <div class="col-md-1 pt-3">
                            <br />
                            <button class="btn btn-primary btn-action" @click="apply" v-if="model.customerType !== 0" :disabled="!isValidApply">
                                {{$t('shared.apply')}}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="stepNumber == 1">
                    <div class="col-md-4">
                        <div class="card-body">
                            <div class="form-group">
                                <div class="input-group md-3 mb-1">
                                    <input class="form-control border-right-0 border-left"
                                           type="text"
                                           v-model="model.senderName"
                                           :placeholder="$t('dashboardPage.senderName')" />
                                    <div class="input-group-append">
                                        <span class="input-group-text right gray">
                                            <i class="fas fa-search"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row " style="margin-top: 10px;">
                    <div class="col-md-12 pr-3">
                        <div class="card card_layout">
                            <div class="card-body">
                                <template>
                                    <v-data-table v-model="selected" :headers="headers" :items="senderNames" select-all
                                                  :rows-per-page-text="$t('shared.rowsPerPage')" :rows-per-page-items="[10, 25, 50, 100]"
                                                  item-key="id" class="elevation-1 table-striped">
                                        <template v-slot:headers="props">
                                            <tr>
                                                <th>
                                                    <v-checkbox :input-value="props.all" :indeterminate="props.indeterminate" primary hide-details
                                                                @click.stop="selectAll"></v-checkbox>
                                                </th>
                                                <th v-for="header in props.headers" :key="header.text"
                                                    class="text-center" :width="header.width !== ''? header.width : ''">
                                                    {{ header.text }}
                                                </th>
                                            </tr>
                                        </template>
                                        <template v-slot:items="props">
                                            <tr>
                                                <td>
                                                    <v-checkbox v-model="props.selected" @change="select($event, props.item.id)" primary
                                                                hide-details></v-checkbox>
                                                </td>
                                                <td class="text-center">{{props.item.senderName }}</td>
                                                <td class="text-center">
                                                    <span v-for="(type, index) in props.item.senderTypes" :key="type">
                                                        {{getSenderTypeText(type) }} {{ index != props.item.senderTypes.length-1? '/':'' }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </template>
                            </div>
                            <div class="card-footer">
                                <div class="form-row justify-content-between align-items-center">
                                    <div class="col-auto mx-3">
                                        <a class="link_light" @click="reset" v-if="stepNumber == 1">{{$t('shared.reset')}}</a>
                                    </div>
                                    <div class="col-auto">
                                        <button class="btn btn-outline-primary px-5 py-2 mx-2" @click="back" v-if="stepNumber > 1">
                                            {{$t('shared.back')}}
                                        </button>
                                        <button class="btn btn-primary px-5 py-2" @click="next" :disabled="!isValidStep"
                                                v-if="stepNumber < 2">
                                            {{$t('shared.next')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Step 222222222222 -->
    <div class="row justify-content-center" v-if="stepNumber === 2 || isSelectOption">
        <div class="col-md-12 pr-0">
            <div class="card card_layout">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3 mb-3">
                            <div class="form-group">
                                <label>{{$t('shared.clientName')}}</label>
                                <input class="form-control" :disabled="true" v-model="selected[0].clientName" type="text" />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>{{$t('shared.customerType')}}</label>
                                <v-select v-model="model.customerType" :disabled="true" :items="customerTypeList" :label="$t('shared.select')"
                                          item-text="name" item-value="id" solo>
                                </v-select>
                            </div>
                        </div>
                        <div class="col-md-3 mb-3" v-if="model.customerType !== 0 && model.customerType !== 3">
                            <div class="form-group">
                                <label v-if="model.customerType === 1">{{$t('shared.budgetNumber')}}</label>
                                <label v-if="model.customerType === 2">{{$t('shared.licenseNumber')}}</label>
                                <label v-if="model.customerType === 4">{{$t('shared.internationalCommercialRegistrationNumber')}}</label>
                                <input class="form-control" :disabled="true" v-model="model.crNumber" type="text" />
                            </div>
                        </div>
                        <div class="col-md-3 mb-3" v-if="model.customerType === 2 ||model.customerType === 3">
                            <div class="form-group">
                                <label>{{$t('shared.enterpriseUnifiedNumber')}}</label>
                                <input class="form-control" :disabled="true" v-model="model.enterpriseUnifiedNumber" type="text" />
                            </div>
                        </div>
                        <div class="col-md-3 mb-3">
                            <div class="form-group">
                                <label>{{$t('shared.durationYear')}}</label>
                                <v-select v-model="addModel.duration"
                                          :items="durationList"
                                          item-text="name"
                                          item-value="id"
                                          :label="$t('shared.select')"
                                          solo>
                                </v-select>
                            </div>
                        </div>
                        <div class="col-md-2 pr-md-0">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <span v-on="on">
                                        <label>{{$t('shared.connectivityAdding')}}</label>
                                    </span>
                                </template>
                                <span>{{$t('shared.autoActivationNote')}}</span>
                            </v-tooltip>
                            <div class="form-group">
                                <input type="radio" id="true" value="true" v-model="addModel.isAutoActivation"
                                        @click="show()" />
                                <label for="true" style="padding: 10px;">{{$t('shared.auto')}}</label>
                                <input type="radio" id="false" value="false" v-model="addModel.isAutoActivation"
                                        @click="hide()" />
                                <label for="false" style="padding: 10px;">{{$t('shared.manual')}}</label>
                            </div>
                        </div>
                        <div class="col-md-4 pr-md-0" v-if="showOperators">
                            <div class="form-group">
                                <label>{{$t('shared.Operator')}}</label>
                                <v-select v-model="addModel.operators" :items="operatorList" multiple
                                            :label="$t('shared.select')" solo>
                                </v-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row " style="margin-top: 10px;">
                    <div class="col-md-12 pr-3">
                        <div class="card card_layout">
                            <div class="card-body">
                                <template>
                                    <v-data-table :headers="headers" :items="selected" select-all
                                                  :rows-per-page-text="$t('shared.rowsPerPage')" :rows-per-page-items="[10, 25, 50, 100]"
                                                  item-key="id" class="elevation-1 table-striped">
                                        <template v-slot:headers="props">
                                            <tr>
                                                <th v-for="header in props.headers" :key="header.text" @click="changeSort(header.value)"
                                                    class="text-center" :width="header.width !== ''? header.width : ''">
                                                    <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
                                                    {{ header.text }}
                                                </th>
                                            </tr>
                                        </template>
                                        <template v-slot:items="props">
                                            <tr>
                                                <td class="text-center">{{props.item.senderName }}</td>
                                                <td class="text-center">
                                                    <span v-for="(type, index) in props.item.senderTypes" :key="type">
                                                        {{getSenderTypeText(type) }} {{ index != props.item.senderTypes.length-1? '/':'' }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </template>
                            </div>
                            <div class="card-footer">
                                <div class="form-row justify-content-between align-items-center">
                                    <div class="col-auto mx-3">
                                        <a class="link_light" @click="reset" v-if="stepNumber == 1">{{$t('shared.reset')}}</a>
                                    </div>
                                    <div class="col-auto d-flex flex-wrap align-items-center">
                                        <button type="button" class="btn btn-outline-primary px-5 py-2 mr-2 mb-2" @click="cancel" v-if="stepNumber > 1">
                                            {{$t('shared.cancel')}}
                                        </button>
                                        <button type="button" class="btn btn-outline-secondary px-4 py-2 mr-2 mb-2"
                                                :disabled="!isValidExtend || extendSubmitInFlight"
                                                @click="confirmExtendPayLater">
                                            {{$t('shared.payLater')}}
                                        </button>
                                        <button type="button" class="btn btn-danger px-5 py-2 mb-2"
                                                :disabled="!isValidExtend || extendSubmitInFlight"
                                                @click="confirmExtendPayNow">
                                            {{$t('shared.payNaw')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>